import JustValidate from 'just-validate';

document.querySelectorAll('.form.popup-form').forEach((form) => {
	const validator = new JustValidate(form);

	form.querySelectorAll('._required').forEach((input)=>{
		validator.addField(input, [
			{
				rule: 'required',
			},
		])
	})
	form.querySelectorAll('._required-mail').forEach((input)=>{
		validator.addField(input, [
			{
				rule: 'required',
			},
			{
				rule: 'email',
			},
		])
	})
	validator.onSuccess(( event ) => {
		fetch(form.getAttribute('action'), { method: 'POST', body: new FormData(form) })
		.then(response => response.json())
		.then(()=>{
			form.classList.remove('_error')
			form.classList.add('_success')
			form.reset()
		})
		.catch(()=>{
			form.classList.add('_error')
			form.classList.remove('_success')
			form.reset()
		});
	});
})


document.querySelectorAll('[data-popup]:not(.js-open-popup-form)').forEach((btn) => {
	btn.addEventListener('click', (e) => {
		const popup = document.querySelector(btn.dataset.popup)
		if (popup) {
			console.log(popup.querySelector('.popup-form'))
			if(popup.querySelector('.popup-form')){
				popup.querySelector('.popup-form').classList.remove('_success')
				popup.querySelector('.popup-form').classList.remove('_error')
				popup.querySelector('.popup-form').reset()
			}

			popup.classList.add('_display')
			setTimeout(function () {
				popup.classList.add('_animate')
			}, 50)
		}
	})
})
document.querySelectorAll('.popup').forEach((popup) => {
	popup.querySelector('.popup__close')?.addEventListener('click', () => {
		popup.classList.remove('_animate')
		setTimeout(function () {
			popup.classList.remove('_display')
		}, 500)
	});
})
